import { render, staticRenderFns } from "./MSettingsFeaturesMentoring.vue?vue&type=template&id=4d1fffc7"
import script from "./MSettingsFeaturesMentoring.vue?vue&type=script&lang=ts"
export * from "./MSettingsFeaturesMentoring.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.37_css-loader@6.11.0_webpack@5.93.0__ejs@3.1.10_hoga_mqdlk73zogqfmm4uknw3a3yvy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports